<template>
  <div
    class="koc-view koc-login-register-redirect-view"
    data-observe-theme
    data-observe-resize
  >
    <main
      v-if="justLogin"
    >
      <auth-login-component @login="login" />
      <div
        v-if="state.showNotification"
        class="koc-notification koc-full"
      >
        <h3>{{ state.notification }}</h3>
        <div
          class="koc-close"
          @click="clearNotification"
        />
      </div>
    </main>
    <main
      v-else
    >
      <auth-login-register-component
        :active-tab="defaultTab"
        @register="register"
        @login="login"
      />
      <div
        v-if="state.showNotification"
        class="koc-notification koc-full"
      >
        <h3>{{ state.notification }}</h3>
        <div
          class="koc-close"
          @click="clearNotification"
        />
      </div>
    </main>
  </div>
</template>

<script src="./login-register-redirect.js"></script>
<style lang="scss" scoped src="./login-register-redirect.scss"></style>
